




import Vue from 'vue';
import UploadLogo from '@/common/components/support/UploadLogo.vue';

export default Vue.extend({
  components: {
    UploadLogo,
  },
});
